var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpeedometer2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 4C8.27614 4 8.5 4.22386 8.5 4.5V6C8.5 6.27614 8.27614 6.5 8 6.5C7.72386 6.5 7.5 6.27614 7.5 6V4.5C7.5 4.22386 7.72386 4 8 4Z",
    fill: "#00A92F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.73223 5.73223C3.9275 5.53697 4.24408 5.53697 4.43934 5.73223L5.35355 6.64645C5.54882 6.84171 5.54882 7.15829 5.35355 7.35355C5.15829 7.54882 4.84171 7.54882 4.64645 7.35355L3.73223 6.43934C3.53697 6.24408 3.53697 5.92749 3.73223 5.73223Z",
    fill: "#00A92F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 10C2 9.72386 2.22386 9.5 2.5 9.5H4.08579C4.36193 9.5 4.58579 9.72386 4.58579 10C4.58579 10.2761 4.36193 10.5 4.08579 10.5H2.5C2.22386 10.5 2 10.2761 2 10Z",
    fill: "#00A92F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 10C11.5 9.72386 11.7239 9.5 12 9.5H13.5C13.7761 9.5 14 9.72386 14 10C14 10.2761 13.7761 10.5 13.5 10.5H12C11.7239 10.5 11.5 10.2761 11.5 10Z",
    fill: "#00A92F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2543 5.75422C12.1109 5.61073 11.8811 5.60182 11.7269 5.73376L7.54727 9.31056C7.14447 9.65526 7.12062 10.27 7.49549 10.6449C7.87901 11.0284 8.51079 10.9932 8.84934 10.5694L12.2832 6.27153C12.4067 6.11691 12.3943 5.89416 12.2543 5.75422Z",
    fill: "#00A92F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 10C0 5.58172 3.58172 2 8 2C12.4183 2 16 5.58172 16 10C16 10.9321 15.8404 11.828 15.5466 12.6612C15.1047 13.9144 13.7023 14.2634 12.6147 13.911C11.3092 13.4879 9.4741 13 8 13C6.5259 13 4.6908 13.4879 3.3853 13.911C2.29768 14.2634 0.89534 13.9144 0.45343 12.6612C0.15962 11.828 0 10.9321 0 10ZM8 3C4.13401 3 1 6.13401 1 10C1 10.8173 1.13985 11.6008 1.39651 12.3286C1.59954 12.9044 2.31979 13.2051 3.07703 12.9597C4.39612 12.5322 6.35838 12 8 12C9.64161 12 11.6039 12.5322 12.923 12.9597C13.6802 13.2051 14.4005 12.9044 14.6035 12.3286C14.8601 11.6008 15 10.8173 15 10C15 6.13401 11.866 3 8 3Z",
    fill: "#00A92F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeedometer2);
export default __webpack_public_path__ + "static/media/speedometer2.831bc7402f1886085094e06e5f5ea479.svg";
export { ForwardRef as ReactComponent };